const _excluded = ["onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useEffect } from 'react';
import { compact } from 'lodash-es';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, Select, Tooltip, useStateInRef } from 'seagull';
import { makeInitialOneTimeInStages } from "../../../business-logic/billingLogic";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { serviceBillingModel } from "../../../models";
import { RecurrencePeriodTypes } from "../../../models/service-billing/model";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { getOccurrenceDisabledData } from "./ServiceBuilder.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const getOccurrenceOptions = IN_STAGES_OCCURENCE => compact([{
  value: 'onetime'
}, IN_STAGES_OCCURENCE && {
  value: 'inStages'
}, {
  value: RecurrencePeriodTypes.Weekly
}, {
  value: RecurrencePeriodTypes.BiWeekly
}, {
  value: RecurrencePeriodTypes.Monthly
}, {
  value: RecurrencePeriodTypes.Quarterly
}, {
  value: RecurrencePeriodTypes.Yearly
}]);
export default function OccurrenceTextField(props) {
  const {
    serviceOrigin,
    service
  } = props;
  const getProps = useStateInRef(props);
  const {
    control,
    watch,
    trigger,
    setValue
  } = useFormContext();
  const {
    disabled,
    tooltip
  } = getOccurrenceDisabledData(serviceOrigin, service);
  const {
    YEARLY_AUTOMATIC_SERVICE,
    IN_STAGES_OCCURENCE = false
  } = useFeatureFlags();
  const billingTrigger = watch('trigger');
  useEffect(() => {
    trigger('recurrencePeriod');
  }, [billingTrigger]);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "recurrencePeriod",
    rules: {
      validate: value => {
        if (billingTrigger === 'ongoing' && value === RecurrencePeriodTypes.Yearly && !YEARLY_AUTOMATIC_SERVICE) {
          return "Invalid value";
        }
        return true;
      }
    },
    render: renderProps => {
      const _connectControllerToT = connectControllerToTextField(renderProps),
        {
          onChange: _onChange
        } = _connectControllerToT,
        rest = _objectWithoutProperties(_connectControllerToT, _excluded);
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tooltip,
        children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, rest), {}, {
          label: "Billing occurrence",
          "data-testid": "sb-occurrence",
          disabled: disabled,
          onChange: e => {
            const newRecurrencePeriod = e.target.value;
            _onChange(e);
            if (IN_STAGES_OCCURENCE) {
              if (newRecurrencePeriod === 'inStages') {
                const {
                  service
                } = getProps();
                const existingOneTimeInStages = service ? serviceBillingModel.oneTimeInStages(service.billing) : null;
                setValue('oneTimeInStagesBilling', existingOneTimeInStages || makeInitialOneTimeInStages(), {
                  shouldDirty: true
                });
              } else {
                setValue('oneTimeInStagesBilling', null, {
                  shouldDirty: true
                });
              }
            }
          },
          children: getOccurrenceOptions(IN_STAGES_OCCURENCE).map(_ref => {
            let {
              value
            } = _ref;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: value,
              "data-testid": "sb-occurrence-opt-".concat(value),
              children: serviceBillingModel.extendedRecurrencePeriodText(value)
            }, value);
          })
        }))
      });
    }
  });
}